import React from 'react'
import createSvgIcon from '../utilities/createSvgIcon'

export default createSvgIcon(
  <>
    <path d="m21 8c-1.45 0-2.26 1.44-1.93 2.51l-3.55 3.56c-.3-.09-.74-.09-1.04 0l-2.55-2.55c.34-1.07-.47-2.52-1.93-2.52-1.45 0-2.27 1.44-1.93 2.52l-4.56 4.55c-1.07-.33-2.51.48-2.51 1.93 0 1.1.9 2 2 2 1.45 0 2.26-1.44 1.93-2.51l4.55-4.56c.3.09.74.09 1.04 0l2.55 2.55c-.34 1.07.47 2.52 1.93 2.52 1.45 0 2.27-1.44 1.93-2.52l3.56-3.55c1.07.33 2.51-.48 2.51-1.93 0-1.1-.9-2-2-2z" />
    <path d="m15 9 .94-2.07 2.06-.93-2.06-.93-.94-2.07-.92 2.07-2.08.93 2.08.93z" />
    <path d="m3.5 11 .5-2 2-.5-2-.5-.5-2-.5 2-2 .5 2 .5z" />
  </>,
  'Analytics',
)
